// Переключение сводок гостей на шаге «Проверка»: по табам гостей и кнопкам
// «Пред./След. анкета». Логика — по аналогии с шагом анкет
// (Visa-order-applications.js), но без полей форм (сводка read-only).
//
//  - переход идёт через один метод go(index), вокруг которого позже можно
//    навесить логику (например, проверку заполненности перед оплатой);
//  - о каждом переключении сообщаем CustomEvent("check:change");
//  - DOM-привязки (табы/панели/кнопки) собраны в одном месте.

document.querySelectorAll(".visa-order-check").forEach(initVisaOrderCheck);
document.querySelectorAll(".visa-order-check").forEach(initOrderPayment);
document.querySelectorAll(".visa-order-payment").forEach(initPaymentConsents);

const ORDER_MID = 3; // mod_order в таблице modules

// «К оплате» — необратимый переход в «Ожидает оплаты» (proceedPayment): после него
// заказ уже нельзя редактировать. Сервер перепроверяет готовность и отдаёт redirect
// на страницу заказа (роутер сам покажет шаг оплаты по статусу).
function initOrderPayment(root) {
	const btn = root.querySelector("[data-order-pay]");
	const blockId = root.dataset.blockId;
	if (!btn || !blockId) return;

	const span = btn.querySelector("span");
	const orig = span ? span.textContent : "";

	// Согласия (оферта + ПД) — кнопка активна, только когда отмечены оба.
	const consents = Array.from(root.querySelectorAll("[data-consent]"));
	const allAgreed = () => consents.every((c) => c.checked);
	const syncBtn = () => { btn.disabled = !allAgreed(); };
	consents.forEach((c) => c.addEventListener("change", syncBtn));
	syncBtn();

	btn.addEventListener("click", async () => {
		if (!allAgreed()) return;
		btn.disabled = true;
		if (span) span.textContent = "Переход к оплате…";

		const data = new FormData();
		data.set("action", "proceedPayment");
		data.set("block_id", blockId);
		consents.forEach((c) => { if (c.name) data.set(c.name, c.checked ? "1" : ""); });

		try {
			const res = await fetch(`/ajax.php?mid=${ORDER_MID}`, { method: "POST", body: data });
			const json = await res.json();
			if (json.success) {
				window.location.href = json.redirect || `/order/${blockId}/`;
				return;
			}
			console.warn("[order] переход к оплате отклонён:", json.error);
			alert(json.error || "Не удалось перейти к оплате");
		} catch (e) {
			console.error("[order] ошибка перехода к оплате:", e);
		}

		if (span) span.textContent = orig;
		btn.disabled = false;
	});
}

// Галочки оферты и ПД — на странице оплаты. «Оплатить» жива, только когда обе отмечены.
function initPaymentConsents(root) {
	const form = root.querySelector("form");
	const btn = form && form.querySelector("[type=submit]");
	const consents = form ? Array.from(form.querySelectorAll("[data-consent]")) : [];
	if (!btn || !consents.length) return;

	const sync = () => { btn.disabled = !consents.every((c) => c.checked); };
	consents.forEach((c) => c.addEventListener("change", sync));
	form.addEventListener("submit", (e) => {
		if (!consents.every((c) => c.checked)) e.preventDefault();
	});
	sync();
}

function initVisaOrderCheck(root) {
	const tabs = Array.from(root.querySelectorAll(".visa-order-check__guest"));
	const panels = Array.from(root.querySelectorAll(".visa-order-check__panel"));
	if (!tabs.length || !panels.length) return;

	const count = Math.min(tabs.length, panels.length);
	const prevBtn = root.querySelector("[data-check-prev]");
	const nextBtn = root.querySelector("[data-check-next]");

	// стартовая сводка — активный таб, иначе первая
	let current = tabs.findIndex((tab) => tab.classList.contains("active"));
	if (current < 0 || current >= count) current = 0;

	function go(index) {
		const target = Math.max(0, Math.min(count - 1, index));
		if (target === current) return;

		current = target;
		render();

		root.dispatchEvent(
			new CustomEvent("check:change", {
				bubbles: true,
				detail: { index: current, total: count },
			})
		);
	}

	function render() {
		tabs.forEach((tab, i) => tab.classList.toggle("active", i === current));
		panels.forEach((panel, i) => {
			const isActive = i === current;
			panel.classList.toggle("is-active", isActive);
			panel.hidden = !isActive;
		});
		syncNav();
	}

	function syncNav() {
		// при одной сводке навигация не нужна вовсе
		const single = count <= 1;
		if (prevBtn) prevBtn.disabled = single || current === 0;
		if (nextBtn) nextBtn.disabled = single || current === count - 1;
	}

	tabs.forEach((tab, i) => {
		const trigger = tab.querySelector(".visa-order-check__guest-select") || tab;
		trigger.addEventListener("click", () => go(i));
	});

	if (prevBtn) prevBtn.addEventListener("click", () => go(current - 1));
	if (nextBtn) nextBtn.addEventListener("click", () => go(current + 1));

	render();
}
